import React from 'react';
import { Chip } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export const Tag = ({
  tag,
  onClick,
  onRemove,
  compact = false,
  touchFriendly = false,
}) => {
  // Calculate sizes based on whether it's compact or touchFriendly
  const height = touchFriendly ? '32px' : (compact ? '18px' : '24px');
  const fontSize = touchFriendly ? '13px' : (compact ? '10px' : '12px');
  const iconSize = touchFriendly ? 18 : (compact ? 12 : 16);
  const labelPadding = touchFriendly ? '0 10px' : (compact ? '0 6px 0 6px' : '0 8px');
  const deleteIconMargin = touchFriendly ? '0 6px 0 -2px' : (compact ? '0 4px 0 -4px' : '0 5px 0 -3px');
  
  return (
    <Chip
      label={tag.name}
      onClick={onClick}
      onDelete={onRemove ? () => onRemove() : undefined}
      deleteIcon={<CloseIcon style={{ width: iconSize, height: iconSize }} />}
      size={touchFriendly ? "medium" : "small"}
      variant="outlined"
      sx={{
        height: height,
        fontSize: fontSize,
        borderRadius: touchFriendly ? '16px' : '12px',
        padding: touchFriendly ? '0 2px' : 0,
        margin: 0,
        backgroundColor: tag.is_system_tag ? 'rgba(32, 36, 45, 0.5)' : 'rgba(25, 39, 90, 0.25)',
        color: tag.is_system_tag ? '#c7c7c7' : '#b0c4ff',
        borderColor: tag.is_system_tag ? 'rgba(123, 123, 123, 0.4)' : 'rgba(88, 119, 230, 0.4)',
        '.MuiChip-label': {
          padding: labelPadding,
          fontWeight: 500,
          lineHeight: 1.2,
        },
        '.MuiChip-deleteIcon': {
          color: tag.is_system_tag ? 'rgba(185, 185, 185, 0.8)' : 'rgba(137, 170, 255, 0.8)',
          margin: deleteIconMargin,
          '&:hover': {
            color: tag.is_system_tag ? '#ffffff' : '#d5e3ff',
          },
        },
        '&:hover': {
          backgroundColor: tag.is_system_tag ? 'rgba(32, 36, 45, 0.7)' : 'rgba(25, 39, 90, 0.45)',
          borderColor: tag.is_system_tag ? 'rgba(123, 123, 123, 0.6)' : 'rgba(88, 119, 230, 0.6)',
        },
      }}
    />
  );
}; 